import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import api from '@/constant/END_POINT'

const createUserApprovalCondition = async (
  backofficeUserId: string,
  approvalConditionId: string,
) => {
  const response = await httpClientPrivate.post(api.backoffice.createUserApprovalCondition, {
    backofficeUserId,
    approvalConditionId,
  })

  return response.data
}

const useCreateUserApprovalCondition = () => {
  const mutation = useMutation({
    mutationKey: ['useCreateUserApprovalCondition'],
    mutationFn: async ({
      backofficeUserId,
      approvalConditionId,
    }: {
      backofficeUserId: string
      approvalConditionId: string
    }) => createUserApprovalCondition(backofficeUserId, approvalConditionId),
  })

  return mutation
}

export { useCreateUserApprovalCondition }
